import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type EnrollmentProfileCompletion = {
  photoSubmitted: boolean
  profileInfoSubmitted: boolean
  identityDocumentsSubmitted: boolean
  healthFormSubmitted: boolean
  testSubmitted: boolean
  scheduleAvailable: boolean
}

export function getEnrollmentProfileCompletion(id: number) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.getEnrollmentProfileCompletion.url, { id }))
    .get<EnrollmentProfileCompletion>()
}
